// src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../api';
import { useBranding } from '../context/BrandingContext';
import BrandingLogo from '../components/BrandingLogo';
import Button from '../components/common/Button';
import { TextInput } from '../components/common/form';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { ready } = useBranding();
  const [value, setValue] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    try {
      setSubmitting(true);
      await API.post('/auth/forgot-password', { emailOrUsername: value.trim() });
      setSent(true);
    } catch {
      setSent(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-accent-50 px-4 py-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-2xl shadow-lg mb-4 p-2">
            <BrandingLogo
              className="w-full h-full object-contain rounded-xl"
              boxClassName="w-full h-full rounded-xl"
            />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('authPages.forgotTitle')}</h1>
          <p className="text-gray-600">{t('accountAccess.passwordReset.pageSubtitle')}</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          {sent ? (
            <div className="space-y-6">
              <div className="rounded-lg border border-success-200 bg-success-50 px-4 py-3 text-sm text-success-800">
                {t('accountAccess.passwordReset.successMessage')}
              </div>
              <Link
                to="/login"
                className="block w-full text-center btn-primary py-3 text-base font-semibold shadow-md hover:shadow-lg"
              >
                {t('authPages.backToSignIn')}
              </Link>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-5">
              <TextInput
                id="emailOrUsername"
                label={t('authPages.emailOrUsername')}
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={t('authPages.emailOrUsernamePlaceholder')}
                autoFocus
                required
              />

              <Button
                type="submit"
                variant="primary"
                className="w-full py-3 text-base font-semibold shadow-md hover:shadow-lg"
                disabled={submitting}
              >
                {submitting ? t('authPages.sending') : t('accountAccess.passwordReset.submitButton')}
              </Button>

              <div className="text-center pt-2">
                <Link
                  to="/login"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium hover:underline"
                >
                  {t('authPages.backToSignIn')}
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
